module.exports = __webpack_public_path__ + "img/ROS_Logo_White.2c95f988.svg";